module.exports = __webpack_public_path__ + "media/18.f1b96251.mp3";